var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgChk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_tick-circle",
    "data-name": "vuesax/bold/tick-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.333,0a8.333,8.333,0,1,0,8.333,8.333A8.347,8.347,0,0,0,8.333,0Zm3.983,6.417L7.592,11.142a.624.624,0,0,1-.883,0L4.35,8.783A.625.625,0,0,1,5.233,7.9L7.15,9.817l4.283-4.283a.625.625,0,0,1,.883.883Z",
    transform: "translate(1.667 1.667)",
    fill: "#255300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgChk);
export default __webpack_public_path__ + "static/media/SvgChk.11663be6d22866f1536f72beadf67d90.svg";
export { ForwardRef as ReactComponent };